export default {"src":"/_next/static/media/mascot-upset.c54d6b7d.gif","height":200,"width":200,"blurWidth":0,"blurHeight":0};